<template>
  <!-- w-19 h-15 -->
  <path
    d="M2 7.56292L1.22967 8.20056L0.706932 7.56905L1.22366 6.93261L2 7.56292ZM6.55202 0.369809C6.90013 -0.0589526 7.52991 -0.124331 7.95867 0.223781C8.38743 0.571894 8.45281 1.20167 8.1047 1.63044L6.55202 0.369809ZM8.09869 13.3625C8.45085 13.7879 8.39144 14.4183 7.966 14.7705C7.54056 15.1226 6.91018 15.0632 6.55802 14.6378L8.09869 13.3625ZM19 8.56292H2V6.56292H19V8.56292ZM1.22366 6.93261L6.55202 0.369809L8.1047 1.63044L2.77634 8.19324L1.22366 6.93261ZM2.77033 6.92528L8.09869 13.3625L6.55802 14.6378L1.22967 8.20056L2.77033 6.92528Z"
    fill="#ABABAB"
  />
</template>
